import { Component, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-responsavel',
  templateUrl: './modal-responsavel.component.html',
  styleUrls: ['./modal-responsavel.component.scss']
})
export class ModalResponsavelComponent {

  modalRef?: BsModalRef;
  objetos: any;

  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
    private modalService: BsModalService,
  ) { }

  openModal(objetos) {
    this.objetos = objetos;
    this.modalRef = this.modalService.show(this.modal);
  }

  closeModal() {
    this.objetos = [];
    this.modalRef?.hide();
  }

}
